import AgreementType from "../component/rule/AgreementType.vue";
import Bool from "../component/rule/Bool";
import Datasource from "../component/rule/Datasource";
import Datasubject from "../component/rule/Datasubject";
import Department from "../component/rule/Department";
import DifferentCountry from "../component/rule/DifferentCountry.vue";
import PhysicalStorage from "../component/rule/PhysicalStorage";
import PhysicalStorageCategory from "../component/rule/PhysicalStorageCategory";
import PolicyStatus from "../component/rule/PolicyStatus";
import Process from "../component/rule/Process";
import ReceiverGroup from "../component/rule/ReceiverGroup";
import RoadmapStage from "../component/rule/RoadmapStage";
import Role from "../component/rule/Role";
import TransferindDirection from "../component/rule/TransferindDirection";
import Always from "./always";

export default [
  {
    identifier: "commons.always",
    name: "Her zaman geçer (Always True)",
    component: Always,
    initialValue: () => ({
      value: true,
      operator: "always",
    }),
  },

  //Deparment
  {
    displayOnWhen: ["DEPARTMENT_CREATED", "PROCESS_CREATED"],
    identifier: "department.self",
    name: "Birim",
    component: Department,
    initialValue: () => ({
      path: "libraryItem",
      value: undefined,
      operator: "in",
    }),
  },

  //Process
  {
    displayOnWhen: ["PROCESS_CREATED", "DATASOURCE_CREATED", "DATASOURCE_UPDATED"],
    identifier: "process.self",
    name: "Süreç",
    component: Process,
    initialValue: () => ({
      path: "process.libraryItem",
      value: undefined,
      operator: "in",
    }),
  },

  //Datasource
  {
    displayOnWhen: ["DATASOURCE_CREATED", "DATASOURCE_UPDATED"],
    identifier: "datasource.self",
    name: "Veri Kaynağı",
    component: Datasource,
    initialValue: () => ({
      path: "datasource.libraryItem",
      value: undefined,
      operator: "in",
    }),
  },

  //Datasubject
  {
    displayOnWhen: ["DATASUBJECT_CREATED"],
    identifier: "datasubject.self",
    name: "İlgili Kişi",
    component: Datasubject,
    initialValue: () => ({
      path: "datasubject.libraryItem",
      value: undefined,
      operator: "in",
    }),
  },
  {
    displayOnWhen: ["DATASOURCE_UPDATED"],
    identifier: "datasource.completed",
    name: "Veri Kaynağı Tamamlandı Olarak İşaretlendi",
    component: Bool,
    initialValue: () => ({
      path: "completed",
      value: true,
      operator: "equals",
    }),
  },

  //thirdParty
  {
    displayOnWhen: ["THIRDPARTY_CREATED"],
    identifier: "thirdparty.self",
    component: TransferindDirection,
    name: "Veri Aktarım Yönü",
    initialValue: () => ({
      path: "direction",
      value: undefined,
      operator: "equals",
    }),
  },

  {
    displayOnWhen: ["THIRDPARTY_CREATED"],
    identifier: "receivergroup.self",
    component: ReceiverGroup,
    name: "Alıcı Grubu",
    initialValue: () => ({
      path: "receiverGroup.libraryItem",
      value: undefined,
      operator: "equals",
    }),
  },
  {
    displayOnWhen: ["THIRDPARTY_CREATED"],
    identifier: "softwareProvider.self",
    component: Bool,
    name: "Yazılım Sağlayıcısı mı?",
    initialValue: () => ({
      path: "softwareProvider",
      value: undefined,
      operator: "equals",
    }),
  },
  {
    displayOnWhen: ["THIRDPARTY_CREATED"],
    identifier: "differentCountry.self",
    component: DifferentCountry,
    name: "Üçüncü taraf ülkesi ile organizasyon ülkesi eşit değil ise",
    initialValue: () => ({
      path: "abroad",
      value: true,
      operator: "equals",
    }),
  },
  {
    displayOnWhen: ["THIRDPARTY_CREATED"],
    identifier: "agreementType.self",
    component: AgreementType,
    name: "Anlaşma Tipi",
    initialValue: () => ({
      path: "agreementType",
      value: undefined,
      operator: "equals",
    }),
  },

  //Physical Storage
  {
    displayOnWhen: ["DATASOURCE_PHYSICAL_STORAGE_CREATED"],
    identifier: "physical-storage.self",
    name: "Fiziksel Saklama Ortamı",
    component: PhysicalStorage,
    initialValue: () => ({
      path: "libraryItem",
      value: undefined,
      operator: "in",
    }),
  },

  {
    displayOnWhen: ["DATASOURCE_PHYSICAL_STORAGE_CREATED"],
    identifier: "physical-storage.category",
    name: "Fiziksel Saklama Kategorisi",
    component: PhysicalStorageCategory,
    initialValue: () => ({
      path: "category",
      value: undefined,
      operator: "in",
    }),
  },
  {
    displayOnWhen: ["DATASOURCE_PHYSICAL_STORAGE_CREATED"],
    identifier: "physical-storage.category.secured",
    name: "Fiziksel Saklama Ortam Kategorisi Güvenli İşaretli mi?",
    component: Bool,
    initialValue: () => ({
      path: "category.secure",
      value: undefined,
      operator: "equals",
    }),
  },

  //Account Role
  {
    displayOnWhen: ["ORGANIZATION_MEMBER_JOINED", "ORGANIZATION_MEMBER_ROLE_CHANGED"],
    identifier: "acl.role",
    name: "Kullanıcının Organizasyondaki Rolleri",
    component: Role,
    initialValue: () => ({
      path: "roles.[]._id",
      value: undefined,
      operator: "some",
    }),
  },

  //Roadmap
  {
    displayOnWhen: ["ROADMAP_STAGE_COMPLETED"],
    identifier: "roadmap.self",
    name: "Roadmap Aşaması",
    component: RoadmapStage,
    initialValue: () => ({
      path: "definition",
      value: undefined,
      operator: "equals",
    }),
  },

  //Policy
  {
    displayOnWhen: ["POLICY_STATUS_CHANGED"],
    identifier: "policy.acceptance",
    name: "Tedbir Statusü",
    component: PolicyStatus,
    initialValue: () => ({
      path: "acceptance",
      value: undefined,
      operator: "equals",
    }),
  },
];
